import * as serviceOrdering from "./ServiceOrderingRoutes";
import SelectAppointmentPage from "../pages/SelectAppointmentPage";
import ServiceOrderingPage from "../pages/ServiceOrderingPage";

export const ServiceOrderingRoutes = [
  {
    key: "new-order",
    exact: true,
    path: serviceOrdering.SERVICE_ORDERING,
    component: ServiceOrderingPage,
  },
  {
    key: "select-appointment",
    exact: true,
    path: serviceOrdering.SELECT_APPOINTMENT,
    component: SelectAppointmentPage,
  },
];
